import { input, Component, ChangeDetectionStrategy } from '@angular/core';

import { SvgIcon } from '@/app/shared/components/ui/svg-icon';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.html',
  styleUrl: './progress-spinner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SvgIcon],
  host: {
    class: 'app-progress-spinner',
  },
})
export class ProgressSpinner {
  size = input<number>(20);
}
